import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DataDictionaryApiKeysEmptyState } from './DataDictionaryApiKeysEmptyState';
import { SonarCard } from '@ui/general';
import { SortByFilterQueryParams } from '@periscopes/general/filters';
import { SortedBySelect } from '@ui/table-modifier/SortedBy';

import { Flex, Typography } from 'antd';
import React, { useCallback, useState } from 'react';
import { SonarV3SortDirection, SortByOption } from '@sonar-software/sonar-ts-types';

const { Paragraph } = Typography;

const sortOptions: Array<SortByOption> = [
	{
		direction: SonarV3SortDirection.Ascending,
		key: 'name',
		label: COPY_SPECIFIC.NAME
	},
	{
		direction: SonarV3SortDirection.Descending,
		key: 'lastUsed',
		label: COPY_SPECIFIC.LAST_USED
	},
	{
		direction: SonarV3SortDirection.Descending,
		key: 'created',
		label: COPY_SPECIFIC.CREATED
	}
];

export const DataDictionaryApiKeysList: React.FC = () => {
	const [ queryParams, setQueryParams ] = useState<SortByFilterQueryParams>({
		sortBy: sortOptions[ 0 ].key,
		sortDirection: sortOptions[ 0 ].direction
	});

	const handleSortUpdate = useCallback((update: SortByFilterQueryParams) => {
		setQueryParams((prev) => ({ ...prev,
			...update }));
	}, []);

	return (
		<SonarCard
			id='data-dictionary-api-keys-card'
			title={ `${COPY_SPECIFIC.DATA_DICTIONARY} ${COPY_SPECIFIC.API_KEYS}` }>
			<Paragraph className='api-keys-description'>
				{ COPY_SPECIFIC.MANAGE_API_KEYS }
			</Paragraph>
			<Flex
				align='center'
				justify='flex-end'>
				<SortedBySelect
					defaultValue={ sortOptions[ 0 ] }
					onChange={ handleSortUpdate }
					queryParams={ queryParams }
					sortOptions={ sortOptions } />
			</Flex>

			{ /* TODO: the onCreate will implement in sc-21928 */ }
			<DataDictionaryApiKeysEmptyState onCreate={ undefined } />
		</SonarCard>
	);
};
